const minin = {
  data() {
    return {
      baseUrl: 'repair',
      form: {
        type: null,
        carid: undefined,
        articleid: undefined,
        license: undefined,
        maunit: undefined,
        rstarttime: undefined,
        money: undefined,
        repair: undefined,
      },
      rules: {
        type: [
          { required: true, message: "请选择车辆类型", trigger: "blur" },
        ],
        carid: [
          { required: true, message: "请选择车牌号", trigger: "blur" },
        ],
        // license: [
        //   { required: true, message: "请选择车牌号", trigger: "blur" },
        // ],
        articleid: [
          { required: true, message: "请选择维保类型", trigger: "blur" },
        ],
        maunit: [
          { required: true, message: "请填写维保厂家", trigger: "blur" },
        ],
        rstarttime: [
          { required: true, message: "请选择时间", trigger: "blur" },
        ],
        money: [
          { required: true, message: "请填写金额", trigger: "blur" },
        ],
      },
      formCtrl: [
        {
          label: "种类",
          keyName: "type",
          err: "请选择",
          type: "select",
          options: [
            { label: '车头', value: 1 },
            { label: '挂车', value: 2 },
          ],
        },
        {
          label: "车牌号",
          // keyName: "license",
          keyName: "carid",
          err: "请选择车牌号",
          type: "select",
          options: [],
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          disabled: true,
        },
        {
          label: "维保类型",
          keyName: "articleid",
          err: "请选择",
          type: "select",
          options: [],
        },
        {
          label: "维保厂家",
          keyName: "maunit",
          err: "请选择维保厂家",
          type: "text",
          // type: "select",
          options: [],
        },
        {
          label: "维保时间",
          keyName: "rstarttime",
          err: "请选择时间",
          type: "date",
        },
        {
          label: "维保金额(元)",
          keyName: "money",
          err: "请填写金额",
          type: "number",
        },
        {
          label: "维保票据",
          keyName: "photo",
          tips: "最多上传2张图片",
          type: "file",
          ptype: "repair",
          max: 2,
          className: 'block',
        },
        {
          label: "维保照片",
          keyName: "bill",
          tips: "最多上传5张图片",
          type: "file",
          ptype: "repair",
          max: 5,
          className: 'block',
        },
        {
          label: "备注",
          keyName: "repair",
          err: "请填写内容",
          type: "textarea",
          rows: '3',
          className: 'block',
        },
      ],
      rejectCtrl: {
        label: "驳回原因",
        keyName: "reject_reason",
        type: "textarea",
        viewMode: true,
        className: "block",
        rows: 4,
      },
      cars: [],
      trailer: [],
    };
  },
  computed: {
    // 是否显示驳回按钮
    hideRejectBtn() {
      let boo = false
      const { user_group_id } = this.user
      const { is_status, add_group_id } = this.detail
      if (
        // 自己改自己的单子
        add_group_id == user_group_id && (
          // 1 车队长审核，2 机务审核，3 退回修改，4 审核通过
          // 司机
          (user_group_id == 9 && is_status == 3) ||
          // 队长
          (user_group_id == 5 && is_status == 3) ||
          // 超管
          (user_group_id == 1 && is_status == 4)
        ) || !this.$route.fullPath.includes('?') // 添加页不展示按钮
      ) {
        boo = true
      }
      return boo
    },
  },
  methods: {
    onRejectSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$prompt('', '驳回原因', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.rejectReq(value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    rejectReq(reject_reason) {
      this.loading = true
      let url = `repair/reject`;
      const params = {
        id: this.id,
        userid: this.user.id,
        reject_reason
      }
      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '驳回成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '驳回失败，请稍后重试！'
        });
      })
    },
    onCheckSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$refs['form'].validate((valid) => {
        const boo = this.formOrtherValidate()
        // console.log(valid, boo)
        if (valid && boo) {
          this.$confirm('确认审核通过吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.checkSubmitReq()
          }).catch(() => { });
        } else {
          console.log('验证不通过');
          return false;
        }
      });
    },
    checkParamsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            // console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
      let is_status = 1
      const { user_group_id } = this.user
      if (user_group_id == 1) {
        // 超管默认提交归档
        // is_status = 4
      }
      if (user_group_id == 5) {
        // 队长审核通过
        is_status = 4
      }
      params['is_status'] = is_status
    },
    checkSubmitReq() {
      this.loading = true
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      }
      this.checkParamsPackage(params, this.form)
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }
      console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    onSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$refs['form'].validate((valid) => {
        const boo = this.formOrtherValidate()
        // console.log(valid, boo)
        if (valid && boo) {
          this.$confirm('确认提交吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submitReq()
          }).catch(() => { });
        } else {
          console.log('验证不通过');
          return false;
        }
      });
    },
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            // console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
      const { add_group_id, is_status } = this.detail
      // 储存默认审核状态
      let isstatus = is_status || 1
      const { user_group_id } = this.user
      // console.log(add_group_id)
      if ((user_group_id == 1 && add_group_id == 1) || (user_group_id == 5 && add_group_id == 5)) {
        // 超管默认提交归档
        isstatus = 4
      }
      params['is_status'] = isstatus
    },
    submitReq() {
      this.loading = true
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      }
      this.paramsPackage(params, this.form)
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }
      // console.log({...this.detail})
      console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (key === 'type') {
        this.$set(this.form, key, value)
        this.$set(this.form, 'carid', null)
        this.formCtrl.map(c => {
          if (c.label == '车牌号') {
            if (value === 1) {
              c.options = [...this.cars]
            } else {
              c.options = [...this.trailer]
            }
          }
        })
      } else if (key === 'carid') {
        this.$set(this.form, key, value)
        this.formCtrl.map(v => {
          if (v.label == '车牌号') {
            v['options'].map(c => {
              // console.log({ ...c })
              if (value === c.value) {
                this.$set(this.form, 'driver', c.driver)
              }
            })
          }
        })
      } else {
        this.$set(this.form, key, value)
      }
      // console.log({ ...this.form });
    },
    setOptions({ car, trailer, article, reunit }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'carid') {
          // c.options = car.map(v => {
          //   return {
          //     label: v.license,
          //     value: v.license,
          //   }
          // })
          if (car && car.length) {
            this.cars = car.map(v => {
              return {
                label: v.license,
                value: v.id,
                driver: v.driver,
              }
            })
          }
          if (trailer && trailer.length) {
            this.trailer = trailer.map(v => {
              return {
                label: v.license,
                value: v.id,
                driver: v.driver,
              }
            })
          }
          if (this.detail['type'] == 2) {
            c.options = [...this.trailer]
          } else {
            c.options = [...this.cars]
          }
        } else if (c.keyName == 'articleid' && article && article.length) {
          c.options = article.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
          // if (!this.form['articleid']) {
          //   this.form['articleid'] = article[0].id
          // }
        } else if (c.keyName == 'maunit' && reunit && reunit.length) {
          // c.options = reunit.map(v => {
          //   return {
          //     label: v.maunit,
          //     value: v.maunit,
          //   }
          // })
        }
        // if (maunit) {
        //   this.form.articleid = maunit.articleid
        //   this.form.maunit = maunit.maunit
        // }
        this.$forceUpdate()
      })
      // console.log('form', { ...this.form });
      // console.log('formCtrl', [...this.formCtrl]);
    },
    onInput({ key, value }) {
      console.log(key, value)
      if (['maunit'].includes(key) && value) {
        this.inputSearch(key, value)
      } else if (!value) {
        this.formCtrl.map(v => {
          if (v.keyName == 'maunit') {
            v['options'] = []
          }
        })
        this.$forceUpdate()
      }
    },
    inputSearch(key, value) {
      // console.log(id, key, value)
      let url = `${this.baseUrl}/maunit`;
      const params = {
        [key]: value,
      }
      // console.log(url, params)
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          this.formCtrl.map(v => {
            if (v.keyName == 'maunit') {
              v['options'] = data.map(v => {
                return {
                  label: v.maunit,
                  value: v.id,
                  data: v,
                }
              })
            }
          })
          this.$forceUpdate()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSelect({ key, value }) {
      // console.log(key, value)
      this.formCtrl.map(v => {
        if (v.keyName == 'maunit') {
          v['options'] = []
        }
      })
      if (value) {
        this.$set(this.form, key, value[key])
      }
      this.$forceUpdate()
    },
  },
  mounted() {
    if (!this.form.type) {
      this.$set(this.form, 'type', 1)
    }
    this.getOptions({ userid: this.user.id })
  },
}

export default minin